import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'
import type { UpcomingEventsData, NameDayInfo } from '@/lib/types'

export function useUpcomingEvents() {
  return useQuery({
    queryKey: ['upcoming-events'],
    queryFn: () => api<UpcomingEventsData>('/api/upcoming-events'),
  })
}

export function useNameDay(firstName: string | undefined) {
  return useQuery({
    queryKey: ['name-day', firstName],
    queryFn: () => api<NameDayInfo>(`/api/saints/nameday?name=${encodeURIComponent(firstName!)}`),
    enabled: !!firstName,
  })
}
